import { reduce } from 'ramda'

/**
 * Adapter factory.
 */
export default class HttpCacheAdapterFactory {
  /**
   * Constructor
   *
   * @param {Array<HttpCacheAbstractAdapter>} adapters
   */
  constructor(adapters) {
    this.adapters = adapters
  }

  /**
   * Creates an adapter for a given pool.
   *
   * @param {HttpCachePoolConfig} poolConfig
   * @return {HttpCacheAbstractAdapter}
   */
  create(poolConfig) {
    const adapter = reduce(
      (carry, adapter) => (adapter.supports(poolConfig) ? adapter : carry),
      null,
      this.adapters,
    )

    if (adapter === null) {
      throw new Error(`Adapter not found for pool ${poolConfig.name}`)
    }

    return adapter
  }
}
